import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { DcrSuccessIcon } from '@/assets/icons/DcrSuccessIcon';

import { dcrSuccessModalContentStyles as sx } from './DcrSuccessModalContent.styles';

type Props = {
	onClose: () => void;
};

export const DcrSuccessModalContent = ({ onClose }: Props) => {
	const { t } = useTranslation();

	return (
		<Box onClick={onClose} sx={sx.root}>
			<DcrSuccessIcon sx={sx.icon} />
			<Typography>{t('Your request has been sent!')}</Typography>

			<Button sx={sx.button} variant='contained'>
				{t('Close')}
			</Button>
		</Box>
	);
};
